export default __webpack_public_path__ + "static/media/openscience_funding_en.2c451715.png";